import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent implements OnInit {

  facebookUrl = 'https://www.facebook.com/camben';
  tiktokUrl = 'https://www.tiktok.com/@camben';
  youtubeUrl = 'https://www.youtube.com/channel/camben';
  linkedinUrl = 'https://www.linkedin.com/company/camben';

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit(): void {
    // --- OPTIMIZACIÓN DE TÍTULO: MÁXIMA AUTORIDAD Y ALCANCE INTERNACIONAL ---
    this.titleService.setTitle('CAMBEN | Fábrica Oficial: Uniformes y Accesorios Adventistas con Envíos Internacionales y Envío Gratis en México');

    // --- OPTIMIZACIÓN DE META ETIQUETAS PARA SEO AGRESIVO Y CONVENIENCIA ---
    this.metaService.addTags([
      { 
        name: 'description', 
        content: 'CAMBEN es el proveedor #1 de uniformes y materiales OFICIALES para los Ministerios Juveniles (Guías Mayores, Conquistadores, Aventureros). ¡Todo en un solo lugar! Ofrecemos envíos internacionales y Envío Gratis en México.' 
      },
      { 
        name: 'keywords', 
        content: 'uniformes oficiales adventistas, Club de Conquistadores México, Club de Guías Mayores, Club de Aventureros, envíos internacionales uniformes, tienda única uniformes adventistas, envíos gratis uniformes, CAMBEN, insignias oficiales' 
      },
      { name: 'author', content: 'CAMBEN' },
      
      // --- OPEN GRAPH ---
      { property: 'og:title', content: 'CAMBEN: Uniformes Oficiales Adventistas con Envíos Internacionales y Envío Gratis' },
      { property: 'og:description', content: 'Proveedor líder de uniformes para Conquistadores, Guías Mayores y Aventureros. Fábrica 100% mexicana con calidad garantizada, Envío Gratis en México y soporte internacional.' },
      { property: 'og:image', content: 'https://www.camben.com/assets/images/camben-uniformes-oficiales-social-share.jpg' }, // ¡REEMPLAZA ESTO! 
      { property: 'og:url', content: 'https://www.camben.com/quienes-somos' }
    ]);
  }
}